<template>
<div>
    <form @submit.prevent="submit()">
      <div class="form-group">
        <label for="">Startnummer</label>
        <input type="text" class="form-control" placeholder="Ihre Startnummer" v-model="bib">
      </div>
      <div class="form-group">
        <label for="">T-Shirt zuschicken?</label>
        <select class="form-control" placeholder="T-Shirt zuschicken?" v-model="tshirt_shipping">
          <option :value="undefined" disabled selected>T-Shirt zuschicken?</option>
          <option value="no">Nein, ich hole mein T-Shirt im Laden ab</option>
          <option value="yes">Ja, bitte zuschicken</option>
        </select>
      </div>
      <div v-if="errors.length > 0" class="alert alert-danger mb-3">
        <div v-for="error of errors" :key="error">{{ error }}</div>
      </div>
      <div v-if="status === 'complete'" class="alert alert-success mb-3">
        Ihre Daten wurden erfolgreich gespeichert.
      </div>
      <button class="btn btn-block btn-secondary" :disabled="status == 'processing'">
        <span v-if="status == 'processing'">...</span>
        <span v-else>Speichern</span>
      </button>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default {
  name: 'EditOrderItem',
  data: function() {
    return {
      status: 'idle',
      errors: [],
      accessCode: '',
      bib: '',
      zip: '',
      tshirt_shipping: null,
    }
  },
  mounted() {
    
  },
  methods: {
    submit() {
      this.status = 'processing'
      this.errors = []

      var body = {}

      for (let key in this.value) {
        body[key] = this.value[key]
      }

      body['tshirt_shipping'] = this.tshirt_shipping
      body['bib'] = this.bib

      body['features'] = this.features
      
      var accessCode = this.accessCode || '0'
      
      var url = process.env.VUE_APP_API_URL + '/users/' + accessCode + '/data'
      
      axios.post(url, body, {
        withCredentials: true,
      }).then(response => {
        this.status = 'complete'
        console.log(response)
      }).catch(error => {
        const data = error.response.data
        for (let key in data.errors) {
          const error = data.errors[key]
          this.errors = this.errors.concat(error)
        }
        this.status = 'idle'
      })
    }
  },
  components: {
  }
}
</script>